import { render, staticRenderFns } from "./GrScrollPanel.vue?vue&type=template&id=06a241cd&scoped=true&"
import script from "./GrScrollPanel.vue?vue&type=script&lang=ts&"
export * from "./GrScrollPanel.vue?vue&type=script&lang=ts&"
import style0 from "./GrScrollPanel.vue?vue&type=style&index=0&id=06a241cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a241cd",
  null
  
)

export default component.exports